const GuestSpeakerCard = ({ pfp, name, role, linkedin, github, twitter }) => {

  return (
    <div className="guest__card">
      <div className="guest__card--img">
        <img src={pfp} alt='pfp' />
      </div>
      <div className="guest__card--name">{name}</div>
      <div className="guest__card--role">{role}</div>
      <div className="guest__card--links">

        {
          linkedin &&
          (
            <a href={linkedin} target={"_blank"} rel="noreferrer" data-cursor-enlarge="true" className='guest__card--link guest__card--link-linkedin'>
              <img className='guest__card--link-icon' src='./images/teamicons/linkedin.png' alt="linkedin icon" data-cursor-enlarge="true" />
              <span data-cursor-enlarge="true">LinkedIn</span>
            </a>
          )
        }

        {
          github && (
            <a href={github} target={"_blank"} rel="noreferrer" data-cursor-enlarge="true" className='guest__card--link team__card--link-github'>
              <img className='team__card--link-icon' src='./images/teamicons/github.png' alt="github icon" data-cursor-enlarge="true" />
              <span data-cursor-enlarge="true">Github</span>
            </a>
          )
        }


        {
          twitter && (
            <a href={twitter} target={"_blank"} rel="noreferrer" data-cursor-enlarge="true" className='guest__card--link guest__card--link-twitter'>
              <img className='guest__card--link-icon' src='./images/teamicons/twitter.png' alt="twitter icon" data-cursor-enlarge="true" />
              <span data-cursor-enlarge="true">Twitter</span>
            </a>
          )
        }




      </div>
    </div>
  )
}

export default GuestSpeakerCard;